
export const sFechaPublicacion = '2026-10-13T01:00:52.9548498-06:00';
export const sVersion = 'vf1.1.610130100';
            